import React from "react";
import { TypeIcon } from "./typeIcon";
import styles from "./styles.module.css";

export const CustomDragPreview = (props) => {
  const item = props.monitorProps.item;

  return (
    <div className={styles.customDragPreviewRoot}>
      <div className={styles.icon}>
        <TypeIcon
          droppable={item.droppable}
          hasChildren={item.hasChildren}
          group={item.isGroup}
          level={item.level}
          username={item.username}
        />
      </div>
      <div className={styles.label}>{item.accountName}</div>
    </div>
  );
};
